// removed by extract-text-webpack-plugin
module.exports = {"BoxLeft":"_3tXh1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Payments/Payments.scss
// module id = 611
// module chunks = 0